/* eslint-disable array-callback-return */
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Container, Row, Col } from 'react-grid-system'
import { Link } from 'react-router-dom'
import { MdStore } from 'react-icons/md'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import * as reducks from '../../../reducks'
import { USER_STATUS_TYPE } from '../../../constants/types'
import routes from '../../../config/routes'
import Avatar from '../../commons/Avatar/Avatar'
import AssignStore from '../../commons/AssignStore/AssignStore'
import Breadcrumb from '../../commons/Breadcrumb/Breadcrumb'
import Button from '../../commons/Button/Button'
import Flex from '../../commons/Flex/Flex'
import DefaultLayout from '../../commons/Layouts/DefaultLayout'
import LoadingBounce from '../../commons/LoadingBounce/LoadingBounce'
import Text from '../../commons/Text/Text'
import PeopleWalletEmpty from './PeopleWalletEmpty'
import Thumbnail from '../../commons/Thumbnail/Thumbnail'
import Popover from '../../commons/Popover/Popover'
import {
  FILTERS_STORES_AVAILABLE_GET_ALL,
  SHOW_DETAIL_SUPERVISED,
  SHOW_LIST_WALLET_SUPERVISED,
  UPDATE_STORES_SUPERVISED
} from '../../../constants/roles'
import SeeMoreButton from '../../commons/SeeMoreButton/SeeMoreButton'
import styles from './peopleDetail.module.scss'

const GRADIENT = 99

const breadcrumbs = [
  {
    id: 1,
    title: 'Pessoas',
    path: '/pessoas'
  },
  {
    id: 2,
    title: 'Detalhes'
  }
]

const PeopleDetail = ({
  match: {
    params: { id: stdCodePersonId }
  }
}) => {
  const dispatch = useDispatch()
  const [status, setStatus] = useState()
  const [showPopover, setShowPopover] = useState(false)
  const roles = useSelector((store) => store.currentUserReducer.roles)
  const detail = useSelector((store) => store.supervisedReducer.detail)
  const loading = useSelector((store) => store.supervisedReducer.fetching)
  const wallets = useSelector((store) => store.supervisedReducer.wallets)
  const showPagination =
    wallets.pagination?.currentPage < wallets.pagination?.lastPage

  const showAddStores = useMemo(
    () =>
      roles.includes(FILTERS_STORES_AVAILABLE_GET_ALL) &&
      roles.includes(UPDATE_STORES_SUPERVISED),
    [roles]
  )

  useEffect(() => {
    dispatch(reducks.resources.supervised.actions.clearDetail())

    if (roles.includes(SHOW_DETAIL_SUPERVISED)) {
      dispatch(reducks.resources.supervised.actions.getDetail(stdCodePersonId))
    }

    if (roles.includes(SHOW_LIST_WALLET_SUPERVISED)) {
      dispatch(
        reducks.resources.supervised.actions.getWalletSupervised(
          stdCodePersonId
        )
      )
    }
  }, [stdCodePersonId])

  useEffect(() => {
    if (detail) {
      const findStatus = USER_STATUS_TYPE.find(
        (item) => item.value === detail.status
      )

      setStatus(findStatus)
    }
  }, [detail])

  const handleApply = useCallback(() => {
    setShowPopover(false)
    if (roles.includes(SHOW_LIST_WALLET_SUPERVISED)) {
      dispatch(
        reducks.resources.supervised.actions.getWalletSupervised(
          stdCodePersonId
        )
      )
    }
  }, [dispatch, roles, stdCodePersonId])

  const handleClosePopover = useCallback(() => {
    setShowPopover(false)
  }, [])

  const handleShowPopover = useCallback(() => {
    setShowPopover(true)
  }, [])

  const handlePaginate = () => {
    dispatch(
      reducks.resources.supervised.actions.getWalletSupervised(
        stdCodePersonId,
        {
          page: wallets.pagination.currentPage + 1
        }
      )
    )
  }

  return (
    <DefaultLayout>
      <Container fluid>
        {loading && (
          <Row>
            <Flex
              column
              alignItems="center"
              justifyContent="center"
              height="100%"
            >
              <LoadingBounce />
            </Flex>
          </Row>
        )}
        {!loading && detail && (
          <>
            <Row>
              <Col lg={12}>
                <Text
                  color="gray"
                  size="lg"
                  variation="dark"
                  extraBold
                  ellipsis
                >
                  {detail.name}
                </Text>
              </Col>
            </Row>

            <Row>
              <Col lg={12}>
                <Breadcrumb items={breadcrumbs} />
              </Col>
            </Row>

            <Row>
              <Col md={12} lg={4} xxl={4}>
                <div className={styles.card}>
                  <Avatar title="Carlos Emanoel Pereira Silva" size="medium" />
                  <Text size="md" color="gray" variation="dark" bold>
                    {detail.name}
                  </Text>
                  <Link
                    to={routes.people.personalData.generate(stdCodePersonId)}
                  >
                    <Text size="xs" color="gray" font="custom">
                      Ver dados do consultor
                    </Text>
                  </Link>
                  {status && (
                    <Text
                      size="xs"
                      color={status.color}
                      font="custom"
                      value={status.label}
                    />
                  )}
                </div>
              </Col>

              <Col md={12} lg={4} xxl={4}>
                <div className={styles.card}>
                  <Thumbnail type={GRADIENT}>
                    <MdStore size={25} />
                  </Thumbnail>

                  <Text size="md" color="gray" variation="dark" bold>
                    Dados da Empresa
                  </Text>

                  <Link to={routes.people.company.generate(stdCodePersonId)}>
                    <Text size="xs" color="gray" font="custom">
                      Veja os dados de CNPJ
                    </Text>
                  </Link>
                </div>
              </Col>

              {showAddStores && (
                <Col md={12} lg={4} xxl={4}>
                  <div className={styles.card}>
                    <Text size="md" color="gray" variation="dark" bold>
                      Adicione lojas
                    </Text>

                    <Text size="xs" color="gray" font="custom">
                      Clique no botão para adicionar lojas na carteira do seu
                      consultor
                    </Text>

                    <Popover
                      isOpen={showPopover}
                      preferPlace="left"
                      onOuterAction={handleClosePopover}
                      body={
                        <AssignStore
                          stdCode={stdCodePersonId}
                          onApply={handleApply}
                          callbackClose={handleClosePopover}
                        />
                      }
                    >
                      <Button
                        id="pd_btn_add_store"
                        type="secondary"
                        full
                        onClick={handleShowPopover}
                      >
                        <Text color="white" size="xxs" extraBold>
                          Adicionar lojas
                        </Text>
                      </Button>
                    </Popover>
                  </div>
                </Col>
              )}
            </Row>
          </>
        )}

        <Row style={{ marginTop: 41 }}>
          <Col lg={12}>
            <Text color="gray" size="lg" variation="dark" extraBold>
              Clientes em que atua
            </Text>
          </Col>
        </Row>

        {!wallets.fetching && (
          <Row style={{ padding: '32px 0px' }} align="center" justify="center">
            {wallets.list && wallets.list.length > 0 && (
              <Col lg={12}>
                <div className={styles.list}>
                  {wallets.list.map((wallet) => {
                    let description = wallet.tabNumber

                    if (wallet.groupName) {
                      description = `${wallet.groupName} • ${description}`
                    }

                    return (
                      <Link
                        to={routes.extract.generate(wallet.walletCode)}
                        key={wallet.id}
                        className={styles.item}
                      >
                        <Flex column>
                          <Avatar title={wallet.nameFantasy} size="medium" />
                        </Flex>
                        <Flex column margin="0px 0px 0px 10px">
                          <Text size="md" color="gray" variation="dark" bold>
                            {wallet.nameFantasy}
                          </Text>
                          <Text
                            size="xxs"
                            color="gray"
                            variation="light"
                            font="custom"
                            margin="4px 0px 0px 0px"
                          >
                            {description}
                          </Text>
                        </Flex>
                      </Link>
                    )
                  })}
                </div>
              </Col>
            )}
            {!wallets.list ||
              (wallets.list?.length === 0 && <PeopleWalletEmpty />)}
          </Row>
        )}
        {wallets.fetching && (
          <Row justify="center" style={{ marginTop: 20 }}>
            <LoadingBounce />
          </Row>
        )}
        {!wallets.fetching && showPagination && (
          <Row justify="center" style={{ marginTop: 20, marginBottom: 20 }}>
            <SeeMoreButton handlePaginate={handlePaginate} />
          </Row>
        )}
      </Container>
    </DefaultLayout>
  )
}

PeopleDetail.defaultProps = {
  match: {
    params: {
      id: undefined
    }
  }
}

PeopleDetail.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string
    })
  })
}

export default PeopleDetail
